import { render, staticRenderFns } from "./QueryTigerC.vue?vue&type=template&id=ce2b49da&"
import script from "./QueryTigerC.vue?vue&type=script&lang=js&"
export * from "./QueryTigerC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports